import { Injectable } from '@angular/core';
import { CookieService as NgxCookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class CookieService {
  constructor(private ngxCookieService: NgxCookieService) {}

  setItem(key: string, value: string): void {
    this.ngxCookieService.delete(key, '/');
    this.ngxCookieService.set(key, value, {
      expires: 1,
      path: '/',
      sameSite: 'Lax',
      secure: true,
    });
  }

  getItem(key: string): string | null {
    return this.ngxCookieService.get(key) || null;
  }

  removeItem(key: string, path: string = '/'): void {
    this.ngxCookieService.delete(key, path);
  }

  clear(path: string = '/'): void {
    this.ngxCookieService.deleteAll(path);
  }
}
